// https://5x.ant.design/components/app#global-scene-redux-scene

/* eslint-disable import/no-mutable-exports */

import { App } from '@myua/kit';

let message: ReturnType<typeof App.useApp>['message'];
let notification: ReturnType<typeof App.useApp>['notification'];
let modal: ReturnType<typeof App.useApp>['modal'];

const useInitMethods = () => {
  const staticFunction = App.useApp();
  message = staticFunction.message;
  modal = staticFunction.modal;
  notification = staticFunction.notification;
  return null;
};

const KitMethodsInitializer = () => {
  useInitMethods();
  return null;
};

export { message, modal, notification, KitMethodsInitializer };
